/**
 * Persists intended paid plan (family | premium | legacy_book) across login/register so post-auth
 * redirect can go to /billing/checkout?plan=…
 */
const STORAGE_KEY = 'postAuthBillingPlan';

export function isValidPostAuthBillingPlan(plan) {
  return plan === 'family' || plan === 'premium' || plan === 'legacy_book';
}

/** When URL has ?plan=family|premium|legacy_book, store for use after successful auth */
export function persistBillingPlanFromUrlQuery(planParam) {
  if (!isValidPostAuthBillingPlan(planParam)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, planParam);
  } catch {
    /* ignore quota / private mode */
  }
}

/** Read stored plan, clear storage, return plan or null */
export function consumePendingBillingPlan() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    return isValidPostAuthBillingPlan(raw) ? raw : null;
  } catch {
    return null;
  }
}

/** Link targets between /login and /register while preserving ?plan= */
export function authPathWithPreservedPlan(basePath, planParam) {
  return isValidPostAuthBillingPlan(planParam) ? `${basePath}?plan=${planParam}` : basePath;
}
